import styled from 'styled-components';
import Icon from '../../../atoms/Icon';

const SliderButtonContainer = styled.div`
  cursor: pointer;
  width: 33px;
  height: 33px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.color.gray400};
  &:hover {
    background-color: ${(props) => props.theme.color.gray500};
  }
  margin: 1px;
`;

const SliderButtonIcon = styled(Icon)`
  width: 16px;
  color: ${(props) => props.theme.color.primary800} !important;
  fill: ${(props) => props.theme.color.primary800} !important;
  transform: ${(props) =>
    props.$direction === 'prev' ? 'rotate(180deg)' : 'none'};
`;

/**
 * @param {SliderButtonProps} props
 * @returns {React.ReactElement} The rendered component
 */
const SliderButton = ({ direction, handleClick, className }) => (
  <SliderButtonContainer
    className={className}
    onClick={(e) => handleClick(e, direction)}
  >
    <SliderButtonIcon icon="ARROW_CTA" $direction={direction} />
  </SliderButtonContainer>
);

export default SliderButton;
